import Contact from '../../Components/Contact/Contact'
import ZohoId from '../../Components/ZohoId/ZohoId'
import GryvChecklist from '../../Components/GryvChecklist/GryvChecklist'

// Note: the per-module 'Save' button has been removed. Saving is now driven by
// the global ClientTopHeader button which dispatches CLIENT_TAB_SAVE_ALL.
const ContactTab = () => {
  return (
    <div style={{ width: '100%' }}>
      <ZohoId />
      <GryvChecklist />
      <Contact />
    </div>
  )
}

export default ContactTab
